import {siteName} from '../database/apiv2SiteAccessor'

function matchPsl (site, psl) {
  return site?.access_code ? psl.find(ps => ps?.access_code === site.access_code) : {}
}
export function MergeSiteLists(sites, psl) {
  return sites.map (site=> Object.assign(site, matchPsl(site, psl)))
}

function parseGeoCode(item) {
  let geo = undefined
  const strCoords = item?.site_details?.geo_location ?? item?.geo_location
  if (strCoords) {
    const arrStr = strCoords.split(",")
    if (arrStr.length === 2) {
      const lat = parseFloat(arrStr[0]);
      const long = parseFloat(arrStr[1]);
      geo = [lat, long]
    }
  }
  return geo
}
export function MapMerge (sites, psl) {
  const psm = new Map()
  psl.sort((a, b) => siteName(a).localeCompare(siteName(b)))
  psl.forEach(item => psm.set(item.access_code, item));
  sites.forEach(item => {
    if (psm.has(item.access_code)) {
      const og = psm.get(item.access_code)
      og.site_details = item.site_details
      const geo = parseGeoCode(item)
      if (geo) og.geoCode = geo
      //Object.assign(psm.get(item.access_code), {site_details: item.site_details})
    }
  })
  const arrMerge = Array.from(psm.values())
  return arrMerge
  // return arrMerge.sort((a, b) => siteName(a).localeCompare(siteName(b)))
}
export function MapMergeTest(sites, psl) {
  const psm = new Map()
  const aclist = psl.filter (i => i?.access_code)
  aclist.sort((a, b) => siteName(a).localeCompare(siteName(b)))
  aclist.forEach(item => psm.set(item.access_code, item));
  sites.forEach(item => {
    if (psm.has(item?.access_code)) {
      const og = psm.get(item.access_code)
      og.site_details = item?.site_details ?? (og?.site_details ?? {})
      const geo = parseGeoCode(item)
      if (geo) og.geoCode = geo
    }
  })
  return psm
}